import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Constants } from "../Common/Constants";
import { types } from "../../Redux/Actions/types";
import TextField from "../Common/Fields/TextField";
import ButtonCustom from "../Common/Fields/ButtonCustom";
import {
  exerciseCategoryInsert,
  exerciseCategoryList,
  exerciseCategoryUpdate,
} from "../../Redux/Actions";
import usePermissions from "../Common/Functions/usePermissions";

const ExerciseCategoryForm = () => {
  const dispatch = useDispatch();
  const { exerciseCategorySingle } = useSelector(
    (state) => state.ExerciseCategory
  );
  // Permissions
  const addPermission = usePermissions(Constants.permission.EXER_CATEGORY_ADD);
  const editPermission = usePermissions(
    Constants.permission.EXER_CATEGORY_EDIT
  );
  // Initial values to Exercise Category form
  const [initialValues, setInitialValues] = useState({
    title: "",
  });

  // Validations for Exercise Category form
  const validationSchema = Yup.object().shape({
    title: Yup.string().required(Constants.required),
  });

  useEffect(() => {
    // Set initial values to pre fill exerciseCategorySingle form
    if (exerciseCategorySingle?._id) {
      const editValue = {};
      for (const [key] of Object.entries(initialValues)) {
        if (exerciseCategorySingle[key]) {
          editValue[key] = exerciseCategorySingle[key];
        }
        setInitialValues(editValue);
      }
    }
  }, [exerciseCategorySingle]);

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        // Add or update exerciseCategorySingle API
        let submitFunc = exerciseCategoryInsert(values);
        if (exerciseCategorySingle._id) {
          values.id = exerciseCategorySingle._id;
          submitFunc = exerciseCategoryUpdate(values);
        }
        dispatch(submitFunc).then((response) => {
          if (response.error) {
            dispatch({
              type: types.ERROR_ALERT_VISIBLE,
              payload: response.error,
            });
          } else {
            dispatch({
              type: types.SUCCESS_ALERT_VISIBLE,
              payload: response.message,
            });
            dispatch({ type: types.EXERCISE_CATEGORY_SINGLE, payload: "" });
            dispatch({ type: types.EXERCISE_CATEGORY_FORM_MODEL, payload: "" });
          }
          dispatch(exerciseCategoryList());
        });
      }}
    >
      {({ errors, touched }) => (
        <Form className="row">
          <div className="col-md-12 mb-2">
            <TextField
              type="text"
              name="title"
              className="form-control"
              errors={touched?.title ? errors?.title : undefined}
              touched={touched?.title}
              label={Constants.title}
            />
          </div>
          {((addPermission && !exerciseCategorySingle?._id) ||
            (editPermission && exerciseCategorySingle?._id)) && (
            <ButtonCustom label={Constants.submit} type="submit" />
          )}
        </Form>
      )}
    </Formik>
  );
};

export default ExerciseCategoryForm;
